import { withTranslation } from "@template/components/translation";
import styles from "./TermsAndConditionsLinks.deferred.css";
import PropTypes from "prop-types";

const TermsAndConditionsLinks = ({
  defaultStoreUrl,
  enableComplianceVariant,
  formatTranslation
}) => {
  const termsLink = formatTranslation("loyalty_terms_privacy_hyperlink_copy", {
    termslink: `<a class="${styles.link}" href="${defaultStoreUrl}/terms-and-conditions/">${formatTranslation("loyalty_terms_link")}</a>`,
    privacypolicylink: `<a class="${styles.link}" href="${defaultStoreUrl}/privacy-policy/">${formatTranslation("loyalty_privacy_link")}</a>`
  });

  const content = enableComplianceVariant
    ? `${termsLink}. ${formatTranslation("quick_join_overlay_opt_out_message")}`
    : termsLink;

  return (
    <div
      className={styles.container}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

TermsAndConditionsLinks.propTypes = {
  defaultStoreUrl: PropTypes.string.isRequired,
  enableComplianceVariant: PropTypes.bool.isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(TermsAndConditionsLinks);
